module.exports = __webpack_public_path__ + "assets/bb653a9bb9d7d07e49fb5e8c860557da.mp4";